import { Chip } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

/**
 * Displays one SCIM group member as a deletable chip.
 * Parent Bound context must provide: users (FentraUser[]), onRemove(externalId).
 */
export function FentraMemberChip({ externalId }) {
    const { users, onRemove } = useBoundContext()
    const user = users?.find(matchesExternalId)
    const label = user ? user.displayName || user.userName : externalId

    return <Chip size="small" label={label} onDelete={handleDelete} />

    function matchesExternalId(u) {
        return u.externalId === externalId
    }

    function handleDelete() {
        onRemove(externalId)
    }
}
